module.exports = __webpack_public_path__ + "img/icon-arrow-left.d28e6278.svg";